export { default } from './SWHeroBannerWithSubHeader';
